import React, {useState}							from 'react';

import DevicesDocumentsMenu							from '../Devices/DevicesDocuments';
import Modal										from '../ressources/components/Modal';
import Button										from '../ressources/components/Button';
import Input										from '../ressources/components/Input';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import Tabs											from '../ressources/components/Tabs';
import Select										from '../ressources/components/Select';
import Icon											from '../ressources/components/Icon';
import Checkbox										from '../ressources/components/Checkbox';
import DevicesBadge									from '../ressources/components/Badge/DevicesBadges';
import Textarea										from '../ressources/components/Textarea';
import Avatar										from '../ressources/components/Avatar';
import Switch										from '../ressources/components/Switch';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {InputValues}								from '../ressources/components/Input/interface';
import {SelectValues}								from '../ressources/components/Select/interface';
import {TabsValues}									from '../ressources/components/Tabs/interface';
import {postDevicesApi}								from '../redux/devices/devices';
import {PutDeviceData}								from '../redux/devices/interface';
import {pushUpload, setUploadPercent}				from '../redux/documents/documents';

import {ft_genNotification, ft_pushNotification} 	from '../ressources/functions/notification';
import {ft_selectDataGetMemory, ft_selectDataGetNetwork,
	ft_selectDataGetStockage}						from '../ressources/functions/selectData';
import {ft_formatUserName}							from '../ressources/functions/format';
import {ft_replaceSpecialChar}						from '../ressources/functions/search';

import img_search									from '../ressources/images/icon/search.svg';
import img_copy										from '../ressources/images/icon/copy.svg';
import img_plusSquare								from '../ressources/images/icon/plus-square.svg';
import img_arrowLeftCircle							from '../ressources/images/icon/arrow/left-circle.svg';
import img_arrowRightCircle							from '../ressources/images/icon/arrow/right-circle.svg';
import img_computer									from '../ressources/images/icon/devices/computer.svg';
import img_upload									from '../ressources/images/icon/upload.svg';

import {DEVICE_TYPE, STATE}							from '../ressources/data/form';
import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './Contracts.css';


interface UserAddProps {
	onClose: () => void,
	onConfirm: (idList: string[]) => void
}

interface NewDeviceData {
	name: InputValues,
	deviceType: SelectValues,
	state: SelectValues,
	serial: InputValues,
	screenSize: InputValues,
	processor: InputValues,
	stockage: SelectValues,
	memory: SelectValues,
	gpu: InputValues,
	network: SelectValues,
	description: InputValues,
	documents: File[],
	user: InputValues,
}

const emptyDevice: NewDeviceData = {
	name:        '',
	deviceType:  '',
	state:       '',
	serial:      '',
	screenSize:  '',
	processor:   '',
	stockage:    '',
	memory:      '',
	gpu:         '',
	network:     '',
	description: '',
	documents:   [],
	user:        ''
};

function ContractAddDeviceModal(props: UserAddProps) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const documentsUpload = useAppSelector(state => state.documents.uploadDocument);
	const lang = useAppSelector(state => state.settings.lang);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [newDevices, set_newDevices] = useState<NewDeviceData[]>([emptyDevice]);
	const [view, set_view] = useState<TabsValues>('data');
	const [index, set_index] = useState(0);
	const [load, set_load] = useState(false);

	const [error, set_error] = useState<{[key: string]: string}>({});

	const [search, set_search] = useState<InputValues>('');


	const TEXTE = LANGUAGE(lang);

	function addDevices() {
		const idList: string[] = [];
		let foundError = false;
		let documentCount = 0;

		newDevices.forEach((device, i) => {
			if (foundError)
				return;

			const newError = checkError(device);

			if (Object.values(newError).length === 0)
				return;
			foundError = true;
			set_index(i);
			set_error(newError);
		});

		if (foundError)
			return;

		set_load(true);

		const addDevice = (i: number) => {
			if (!newDevices[i]) {
				set_load(false);
				return props.onConfirm(idList);
			}

			const apiData: PutDeviceData = {
				name:         newDevices[i].name,
				deviceType:   newDevices[i].deviceType,
				state:        newDevices[i].state?.toString(),
				serial:       newDevices[i].serial,
				screenSize:   newDevices[i].screenSize,
				processor:    newDevices[i].processor,
				stockage:     newDevices[i].stockage?.toString(),
				memory:       newDevices[i].memory?.toString(),
				gpu:          newDevices[i].gpu,
				network:      newDevices[i].network?.toString(),
				description:  newDevices[i].description,
				assign:       newDevices[i].user
			};

			// --- Post Device
			dispatch(postDevicesApi({data: apiData, user}))
			.then((response) => {
				if (!response.payload.status) {
					const notificationData = ft_genNotification(TEXTE, 'error', img_computer, response.payload.error);
					ft_pushNotification(dispatch, notificationId, notificationData);
					return set_load(false);
				}
				idList.push(response.payload._id);

				let notificationData = ft_genNotification(TEXTE, 'addDeviceSuccess', img_computer, response.payload.name);
				notificationId = ft_pushNotification(dispatch, notificationId, notificationData);

				// --- Upload Documents
				newDevices[i].documents.map((document) => {
					if (document.size > 2097152)
						return;

					const uploadIndex = documentsUpload.length + documentCount;
					const dispatchData = {index: uploadIndex, dispatch, function: setUploadPercent};
					const uploadFileData = {
						percent:  0,
						filename: document.name,
						size:     document.size,
						id:       response.payload._id
					};
					documentCount++;

					dispatch(pushUpload(uploadFileData));

					API.uploadDeviceDocument(response.payload._id, document, user, dispatchData)
					.then((responseUpload) => {
						if (!responseUpload || !responseUpload.status)
							return dispatch(setUploadPercent({index: uploadIndex, percent: `error: ${responseUpload?.error || ''}`}));

						notificationData = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, response.payload.name);
						notificationId = ft_pushNotification(dispatch, notificationId, notificationData);
					});
				});

				return addDevice(i + 1);
			});
		};

		addDevice(0);
	}

	function checkError(checkedDevice: NewDeviceData) {
		const newError: {[key: string]: string} = {};

		if (!checkedDevice.name)
			newError.name = 'required';
		if (!checkedDevice.deviceType)
			newError.deviceType = 'required';

		return newError;
	}

	function pushNewDevice(duplicate = false) {
		const newError = checkError(newDevices[index]);

		set_error(newError);

		if (Object.values(newError).length > 0)
			return;

		const newData = JSON.parse(JSON.stringify(duplicate ? newDevices[index] : emptyDevice));
		const copy = [...newDevices];

		newData.documents = [];
		copy.push(newData);

		set_newDevices(copy);
		set_index(copy.length - 1);
	}

	function editValue(name: keyof NewDeviceData, value: InputValues | SelectValues) {
		if (name === 'documents')
			return;
		const copy = [...newDevices];

		if (!value)
			value = '';

		copy[index][name] = value;

		set_newDevices(copy);
	}

	function renderHeader() {
		const changeIndex = (newIndex: number) => {
			const newError = checkError(newDevices[index]);
			set_error(newError);

			if (Object.values(newError).length === 0)
				set_index(newIndex);
		};

		return (
			<div className={'contractAddDeviceModalHeader'}>
				<Button
					disabled={index <= 0}
					type={'secondary-gray'}
					icon={img_arrowLeftCircle}
					style={{padding: 8}}
					onClick={() => changeIndex(index - 1)}
				/>
				<span className={'text-md gray-700'}>{`${index + 1} / ${newDevices.length}`}</span>
				<Button
					disabled={index + 1 >= newDevices.length}
					type={'secondary-gray'}
					icon={img_arrowRightCircle}
					style={{padding: 8}}
					onClick={() => changeIndex(index + 1)}
				/>
			</div>
		);
	}

	function renderFooter() {
		return (
			<>
				<div className={'separator'} />
				<MultiInputContainer>
					<Button
						fullWidth
						disabled={load}
						type={'secondary-gray'}
						iconBefore={img_copy}
						onClick={() => pushNewDevice(true)}
					>{TEXTE.global.duplicate}</Button>
					<Button
						fullWidth
						disabled={load}
						type={'secondary-gray'}
						iconBefore={img_plusSquare}
						onClick={() => pushNewDevice()}
					>{TEXTE.contract.newDevice}</Button>
				</MultiInputContainer>
			</>
		);
	}

	function renderViewData() {
		return (
			<div className={'contractAddDeviceModalContainer'}>
				<MultiInputContainer>
					<Select
						required
						error={error.deviceType}
						title={TEXTE.global.deviceType}
						value={newDevices[index].deviceType}
						onChange={val => editValue('deviceType', val)}
						data={DEVICE_TYPE(TEXTE)}
					/>
					<Select
						title={TEXTE.global.state}
						value={newDevices[index].state}
						onChange={val => editValue('state', val)}
						data={STATE(TEXTE)}
					/>
				</MultiInputContainer>

				<Input
					value={newDevices[index].serial}
					onChange={val => editValue('serial', val)}
					title={TEXTE.global.serial}
				/>

				<MultiInputContainer>
					<Input
						min={0}
						type={'number'}
						placeholder={'10,1"'}
						title={TEXTE.global.screenSize}
						value={newDevices[index].screenSize}
						onChange={val => editValue('screenSize', val)}
						notFocusValue={newDevices[index].screenSize ? `${newDevices[index].screenSize}"` : undefined}
					/>
					<Input
						value={newDevices[index].processor}
						onChange={val => editValue('processor', val)}
						title={TEXTE.global.processor}
					/>
				</MultiInputContainer>

				<MultiInputContainer>
					<Select
						value={newDevices[index].stockage}
						onChange={val => editValue('stockage', val)}
						title={TEXTE.global.stockage}
						data={ft_selectDataGetStockage()}
					/>
					<Select
						value={newDevices[index].memory}
						onChange={val => editValue('memory', val)}
						title={TEXTE.global.memory}
						data={ft_selectDataGetMemory()}
					/>
				</MultiInputContainer>

				<MultiInputContainer>
					<Input
						value={newDevices[index].gpu}
						onChange={val => editValue('gpu', val)}
						title={TEXTE.global.gpu}
					/>
					<Select
						value={newDevices[index].network}
						onChange={val => editValue('network', val)}
						title={TEXTE.global.network}
						data={ft_selectDataGetNetwork()}
					/>
				</MultiInputContainer>

				<Textarea
					value={newDevices[index].description}
					onChange={val => editValue('description', val)}
					title={TEXTE.global.description}
					style={{height: 150}}
				/>
			</div>
		);
	}

	function renderViewUsers() {
		const render: JSX.Element[] = [];

		users.forEach((userData) => {
			if (search && !ft_replaceSpecialChar(ft_formatUserName(userData), true, true).includes(ft_replaceSpecialChar(search, true, true)))
				return;

			render.push(
				<tr
					className={`contractTableRow ${newDevices[index].user === userData?._id && 'selected'} ${newDevices[index].user === 'reserve' && 'lock'}`}
					onClick={() => newDevices[index].user !== 'reserve' && editValue('user', userData?._id)}
				>
					<td>
						<div>
							<Checkbox active={newDevices[index].user === userData?._id} />
							<Avatar user={userData} />
							{ft_formatUserName(userData)}
						</div>
					</td>
					<td>
						<DevicesBadge gap={4} userData={userData} />
					</td>
					<td style={{textAlign: 'center'}}>{userData?.job}</td>
				</tr>
			);
		});

		return (
			<div className={'contractAddDeviceModalUsers'}>
				<div className={'contractAddDeviceModalUsersHeader'}>
					<Input
						value={search}
						onChange={set_search}
						placeholder={TEXTE.devices.modal.typeAName}
						before={<Icon icon={img_search} />}
					/>
					<Switch
						text={TEXTE.devices.inReserve}
						active={newDevices[index].user === 'reserve'}
						onChange={() => editValue('user', newDevices[index].user === 'reserve' ? '' : 'reserve')}
					/>
				</div>

				<div className={'contractAddTableContainer'}>
					<table className={'contractTable'}>
						<thead>
							<tr>
								<th>{TEXTE.global.name}</th>
								<th>{TEXTE.global.devices}</th>
								<th>{TEXTE.global.role}</th>
							</tr>
						</thead>
						<tbody>
							{render}
						</tbody>
					</table>
				</div>
			</div>
		);
	}

	return (
		<Modal
			size={654}
			confirmLoad={load}
			onClose={props.onClose}
			confirmButton={addDevices}
			header={<>{renderHeader()}</>}
			footer={<>{renderFooter()}</>}
			confirmButtonText={`${TEXTE.contract.addSelection} (${newDevices.length})`}
		>
			<Input
				textView
				required
				error={error.name}
				value={newDevices[index].name}
				onChange={val => editValue('name', val)}
				placeholder={TEXTE.contract.setDeviceName}
				style={{marginBottom: 17}}
			/>

			<Tabs
				actual={view}
				onChange={set_view}
				data={[
					{value: 'data', render: TEXTE.global.details},
					{value: 'document', render: TEXTE.global.documents},
					{value: 'affect', render: TEXTE.global.affect}
				]}
			/>
			{view === 'data' && renderViewData()}
			{view === 'document' &&
				<div className={'addUserStep step2'}>
					<DevicesDocumentsMenu
						documents={newDevices[index].documents}
						setDocument={(documents) => {
							const copy = [...newDevices];
							copy[index].documents = documents;
							set_newDevices(copy);
						}}
					/>
				</div>
			}
			{view === 'affect' && renderViewUsers()}
		</Modal>
	);
}

export default ContractAddDeviceModal;
